// removed by extract-text-webpack-plugin
module.exports = {"container":"floating-button-spacer__container__2xx0U","container-active":"floating-button-spacer__container-active__25jDQ floating-button-spacer__container__2xx0U","container-active-alabaster":"floating-button-spacer__container-active-alabaster__3xdZM floating-button-spacer__container__2xx0U"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/floating-button-spacer.scss
// module id = 1402
// module chunks = 1